import 'proxy-polyfill/proxy.min.js';
import '../polyfill/arrayFrom-polyfill';

// For the time being this does not even need to be subscribed to.
// If a more component based architecture is pursued it will need to be.
// As it is, it relies on "Pages" maintaining all state and triggering their own rerenders. Components would

// Class should remain flat for easy flat comparison checking
class State {
	jobType = 'proof';

	clientCompanyName = '';
	clientName = '';
	clientEmail = '';
	clientPhone = '';
	clientJob = '';
	clientPurchaseOrder = '';
	clientAdditionalInfo = '';

	hasEstimate = null;
	estimateNumber = '';

	selectedContacts = new Set();
	otherContactName = '';

	submittedFiles = [];
	fileStatuses = {};

	subscribers = [];

	subscribe = callback => {
		this.subscribers.push(callback);
	};
}

const setterProxy = {
	set: function(obj, prop, value) {
		// The default behavior to store the value
		obj[prop] = value;

		const savableState = { ...obj };
		// remove things that dont serialize well
		delete savableState.subscribe;
		delete savableState.subscribers;

		// remove things that dont restore very well
		delete savableState.submittedFiles;
		delete savableState.fileStatuses;

		// Save json string to localStorage
		savableState.selectedContacts = Array.from(
			savableState.selectedContacts
		);
		window.localStorage.setItem('state', JSON.stringify(savableState));

		// Notify subscribers of change
		obj.subscribers.map(callback => {
			callback(obj, prop, value);
		});

		// Indicate success
		return true;
	}
};

export const state = new Proxy(new State(), setterProxy);

export const resetState = function() {
	// create new state and remove methods
	const newState = new State();
	delete newState.subscribe;

	// mutably assign default values to existing state object
	Object.assign(state, newState);
};

export const importState = function(newState) {
	console.log('newState', newState);
	newState.selectedContacts = new Set(newState.selectedContacts);
	Object.assign(state, newState);
};

export const isStateEmpty = () => {
	const currentState = { ...state };
	delete currentState.subscribe;

	const emptyState = new State();
	delete emptyState.subscribe;

	return JSON.stringify(currentState) === JSON.stringify(emptyState);
};

// load savable state from localStorage
const rawLocalState = window.localStorage.getItem('state');
if (rawLocalState) {
	importState(JSON.parse(rawLocalState));
}



// WEBPACK FOOTER //
// ./src/services/state.js